// extracted by mini-css-extract-plugin
module.exports = {"main-card":"LotteryWidgetBlock_main-card__18LLL","second-bar":"LotteryWidgetBlock_second-bar__1FbdB"};